module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDYwMCA2MDAiIHZlcnNpb249IjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiM0REFERjciIGQ9Ik0tMjMtMjdoNjU0djY2MUgtMjN6Ii8+CiAgICA8cGF0aCBkPSJNMjE0IDQzNWMtNTggMC0xMDQtNDQtMTA0LTk4IDAtNDkgMzctODkgODUtOTcgMjItNDEgNjMtNjggMTEwLTY4IDYwIDAgMTEwIDQzIDEyMyAxMDIgMzkgMiA3MSAzNyA3MSA4MCAwIDQyLTMwIDc3LTY5IDgxSDIxNHoiIGZpbGw9IiNGRkYiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/localweather.svg
// module id = 482
// module chunks = 35783957827783